(function() {
  'use strict';

  window.theme = window.theme || {};
  // Delegation also covers theme-editor section replacement without rebinding.
  if (window.theme.productAccordionClickHandler) return;

  window.theme.productAccordionClickHandler = function(event) {
    var button = event.target.closest('[data-product-accordion-toggle]');
    if (!button) return;

    var accordion = button.closest('.product_accordiaon_meta');
    if (!accordion) return;

    var shouldOpen = button.getAttribute('aria-expanded') !== 'true';
    accordion.querySelectorAll('[data-product-accordion-toggle]').forEach(function(toggle) {
      var panel = accordion.querySelector('[id="' + toggle.getAttribute('aria-controls') + '"]');
      if (!panel) return;

      var expanded = toggle === button && shouldOpen;
      toggle.setAttribute('aria-expanded', String(expanded));
      panel.hidden = !expanded;
    });
  };

  document.addEventListener('click', window.theme.productAccordionClickHandler);
})();
